// The Tagesbericht's run by hand, at module level so it outlasts the view: a
// run is one model call of up to about three minutes, and neither leaving the
// view nor coming back to it may start a second one.

import { signal } from "@preact/signals";

import { api } from "@/api/client";
import { insightError } from "@/lib/insights";

export interface InsightRun {
  /** The day being reported (YYYY-MM-DD); "" while no run is in flight. */
  day: string;
  /** When the run in flight started, in ms since the epoch. */
  startedAt: number;
  /** Why the last run failed, in words; "" after a success. */
  error: string;
}

const IDLE: InsightRun = { day: "", startedAt: 0, error: "" };

export const insightRun = signal<InsightRun>(IDLE);
/** The day the view shows; "" shows the newest stored report. */
export const selectedInsightDay = signal<string>("");
/** Moves whenever a run ends, so the list and the shown report reload. */
export const insightsVersion = signal(0);

export const isInsightRunning = (run: InsightRun): boolean => run.day !== "";

/** Builds and stores the report of `day`, replacing the day's earlier one; the
 * view then shows it. */
export async function runInsightReport(day: string): Promise<void> {
  if (!day || isInsightRunning(insightRun.peek())) return;
  insightRun.value = { day, startedAt: Date.now(), error: "" };
  try {
    const report = await api.runInsight({ day });
    selectedInsightDay.value = report.day;
    insightRun.value = IDLE;
  } catch (err) {
    insightRun.value = { ...IDLE, error: insightError(err) };
  } finally {
    // A report the backend stored while its answer got lost shows up as well.
    insightsVersion.value = insightsVersion.peek() + 1;
  }
}
